import { render, staticRenderFns } from "./SetTransferAmountModalSection.vue?vue&type=template&id=35b3e82a&scoped=true"
import script from "./SetTransferAmountModalSection.vue?vue&type=script&lang=js"
export * from "./SetTransferAmountModalSection.vue?vue&type=script&lang=js"
import style0 from "./SetTransferAmountModalSection.vue?vue&type=style&index=0&id=35b3e82a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b3e82a",
  null
  
)

export default component.exports